module.exports = __webpack_public_path__ + "img/renewal_term_filled.53b104a.svg";